var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nav-bar'),_c('aside-menu',{attrs:{"menu":_vm.menu}}),_c('app-main')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }